// removed by extract-text-webpack-plugin
module.exports = {"container":"XbLIywyGKzBeYEM2tYimg"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Logo/styles.css
// module id = 1568
// module chunks = 85